import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["results"];
import http from 'hub-http/clients/apiClient';
import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import * as webInteractivesClient from 'ContentData/api/WebInteractives';
import { getWebInteractiveCache } from 'ContentData/selectors/webInteractives';
import { WEB_INTERACTIVES_FETCH_CALL_TO_ACTION, WEB_INTERACTIVES_FETCH_CALLS_TO_ACTION, WEB_INTERACTIVES_SAVE_CALL_TO_ACTION_CACHE, WEB_INTERACTIVES_CLEAR_CALL_TO_ACTION_CACHE } from 'ContentData/actions/ActionTypes';
const fetchWebInteractiveAction = createGenericFetchAction(WEB_INTERACTIVES_FETCH_CALL_TO_ACTION, webInteractivesClient.fetchWebInteractive);
const fetchWebInteractivesAction = createGenericFetchAction(WEB_INTERACTIVES_FETCH_CALLS_TO_ACTION, webInteractivesClient.fetchWebInteractives);
export const fetchWebInteractive = id => {
  return fetchWebInteractiveAction(id);
};
const mapCrmObjectToWebInteractive = ({
  properties
}) => ({
  id: Number(properties['hs_content_id'].value),
  interactiveContainerType: properties['hs_container_type'].value,
  isPublished: properties['hs_publish_state'].value === 'PUBLISHED',
  name: properties['hs_name'].value,
  screenshotPreviewUrl: properties['hs_screenshot_url'].value
});
export const fetchWebInteractives = query => {
  const {
    request,
    receive,
    error
  } = fetchWebInteractivesAction;
  return (dispatch, getState, {
    httpClient = http
  } = {}) => {
    dispatch(request(query));
    return webInteractivesClient.fetchWebInteractives(query, httpClient).then(_ref => {
      let {
          results
        } = _ref,
        other = _objectWithoutPropertiesLoose(_ref, _excluded);
      return Object.assign({}, other, {
        objects: results.map(mapCrmObjectToWebInteractive)
      });
    }).then(response => {
      dispatch(receive(query, response));
      return response;
    }).catch(__error => {
      dispatch(error(query, __error));
      return __error;
    });
  };

  // Casting because return value can't be null when there's no predicate on fetchWebInteractivesAction
  return fetchWebInteractivesAction(query);
};
export const saveCache = id => {
  return (dispatch, getState) => {
    const cta = getWebInteractiveCache(getState(), {
      id
    });
    dispatch({
      type: WEB_INTERACTIVES_SAVE_CALL_TO_ACTION_CACHE,
      cta
    });
  };
};
export const clearCache = () => {
  return {
    type: WEB_INTERACTIVES_CLEAR_CALL_TO_ACTION_CACHE
  };
};